import { getAuth, User } from "firebase/auth";

/**
 * USAGE GUIDELINES
 *  - Non-React modules (e.g., src/lib, src/utils) must read the current user only via this accessor.
 *  - React components should use the useAuth() hook from AuthProvider instead of calling this directly.
 *  - This indirection allows us to mock or harden auth access uniformly across the app.
 */
export type CurrentUserGetter = () => User | null;

/**
 * Returns the currently signed-in Firebase user, or null if not authenticated.
 * @returns {User | null} The current user object, or null when no user is signed in.
 */
export const defaultGetUser: CurrentUserGetter = () => getAuth().currentUser;